import styled from "styled-components";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";

export const ContentWrapper = styled.div`
  background: ${({ theme }) => theme.colors.neutral00};
  z-index: 3;
`;

export const PageWrapper = styled.div``;

export const DeploymentCardsContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  margin: 0 auto;
  max-width: 100%;
  gap: 32px;
  width: 100%;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    gap: 16px;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    flex-direction: column;
  }
`;

export const DesktopContainer = styled.div`
  display: block;
  width: 100%;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    display: none;
  }
`;

export const MobileContainer = styled.div`
  display: none;
  width: 100%;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    display: block;
  }
`;

export const StyledTitle = styled.h1`
  color: ${({ theme }) => theme.colors.text1};
  font-size: 42px;
  font-weight: bold;
  line-height: normal;
  margin: 0;
  text-align: center;
  text-wrap: balance;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 32px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 28px;
  }
`;

export const StyledSubtitle = styled.h2`
  color ${({ theme }) => theme.colors.text1};
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
  margin: 16px 0 0;
`;
